// extracted by css-extract-rspack-plugin
export default {"listItem":"ListItem2_listItem__ZBThH"};